import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const mockupUrl = (path) => (path ? `${API}/mockups/${path}` : null);

export const PLACEHOLDERS = {
  tshirt: "https://images.pexels.com/photos/12025472/pexels-photo-12025472.jpeg",
  mug: "https://images.pexels.com/photos/8512217/pexels-photo-8512217.jpeg",
  phonecase: "https://images.pexels.com/photos/8947766/pexels-photo-8947766.jpeg",
  coaster: "https://images.unsplash.com/photo-1623305464543-b224da93e482?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  corkcoaster: "https://images.unsplash.com/photo-1623305464543-b224da93e482?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  placemat: "https://images.unsplash.com/photo-1608492024938-bbdd385d5175?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
};

export const productImage = (p) => mockupUrl(p?.preview_path) || mockupUrl(p?.mockup_path) || PLACEHOLDERS[p?.product_type] || PLACEHOLDERS.tshirt;

export const TYPE_LABELS = { tshirt: "T-Shirt", mug: "Mug", phonecase: "Slim Phone Case", phonecase_tough: "Tough Phone Case", hoodie: "Hoodie", sweatshirt: "Sweatshirt", totebag: "Tote Bag", poster: "Poster", sticker: "Sticker", tumbler: "Tumbler", coaster: "Ceramic Coaster", corkcoaster: "Cork Coaster", placemat: "Placemat", pouch: "Accessory Pouch", cancooler: "Can Cooler", carmagnet: "Car Magnet" };

export const THEME_BUCKET = {
  remembrance: "Remembrance", pets: "Remembrance",
  anniversaries: "Milestones", family: "Milestones", hometown: "Milestones",
  friendship: "Milestones", travel: "Milestones", milestones: "Milestones",
  back_to_school: "Milestones",
  appreciation: "Heroes",
  housewarming: "Home & Hearth", gather: "Home & Hearth",
};
export const CATEGORIES = ["Remembrance", "Milestones", "Heroes", "Home & Hearth"];
export const categoryOf = (p) => THEME_BUCKET[p?.theme_key] || null;

export const workflowBadge = {
  review: "bg-purple-100 text-purple-700 border-purple-200",
  draft: "bg-amber-100 text-amber-700 border-amber-200",
  published: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const orderBadge = {
  needs_info: "bg-rose-100 text-rose-700 border-rose-200",
  in_design: "bg-blue-100 text-blue-700 border-blue-200",
  ready: "bg-emerald-100 text-emerald-700 border-emerald-200",
  fulfilled: "bg-zinc-100 text-zinc-600 border-zinc-200",
};

export const levelColor = (v) => {
  const s = String(v || "").toLowerCase();
  if (s === "high") return "text-emerald-600";
  if (s === "low") return "text-rose-600";
  return "text-amber-600";
};

export const scoreColor = (n) => {
  if (n >= 75) return "text-emerald-600";
  if (n >= 55) return "text-blue-600";
  if (n >= 40) return "text-amber-600";
  return "text-zinc-500";
};

export const CHANNELS = [
  { key: "pinterest", label: "Pinterest", color: "#E60023", short: "P" },
  { key: "threads", label: "Threads", color: "#101010", short: "@" },
  { key: "x", label: "X", color: "#101010", short: "X" },
  { key: "instagram", label: "Instagram", color: "#E1306C", short: "IG" },
];

export const socialBadge = {
  review: "bg-amber-100 text-amber-700 border-amber-200",
  posted: "bg-emerald-100 text-emerald-700 border-emerald-200",
  scheduled: "bg-blue-100 text-blue-700 border-blue-200",
};

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
export const money4 = (n) => `$${Number(n || 0).toFixed(4)}`;

export const SALES_CHANNELS = [
  { key: "shopify", label: "Shopify", role: "hub", wholesale: false, desc: "Central catalog hub. Products publish here first, then fan out to connected channels." },
  { key: "tiktok", label: "TikTok Shop", role: "spoke", wholesale: false, desc: "Social commerce via Shopify's TikTok Shop sales channel." },
  { key: "etsy", label: "Etsy", role: "spoke", wholesale: false, desc: "Handmade / POD marketplace via Etsy Marketplace Connect." },
  { key: "faire", label: "Faire", role: "spoke", wholesale: true, desc: "Wholesale marketplace. Requires wholesale pricing & order minimums." },
];

export const channelStatusBadge = {
  published: "bg-emerald-100 text-emerald-700 border-emerald-200",
  draft: "bg-amber-100 text-amber-700 border-amber-200",
  not_listed: "bg-zinc-100 text-zinc-500 border-zinc-200",
};

export const wholesaleBadge = {
  pending: "bg-amber-100 text-amber-700 border-amber-200",
  accepted: "bg-blue-100 text-blue-700 border-blue-200",
  packing: "bg-violet-100 text-violet-700 border-violet-200",
  shipped: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const printifyOrderBadge = {
  "pending": "bg-zinc-100 text-zinc-600 border-zinc-200",
  "on-hold": "bg-amber-100 text-amber-700 border-amber-200",
  "payment-not-received": "bg-amber-100 text-amber-700 border-amber-200",
  "in-production": "bg-blue-100 text-blue-700 border-blue-200",
  "sent-to-production": "bg-blue-100 text-blue-700 border-blue-200",
  "has-issues": "bg-rose-100 text-rose-700 border-rose-200",
  "canceled": "bg-rose-100 text-rose-700 border-rose-200",
  "fulfilled": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "shipped": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "delivered": "bg-emerald-100 text-emerald-700 border-emerald-200",
};
export const printifyOrderLabel = (s) => (s || "pending").replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const modeBadge = {
  personalized: "bg-violet-100 text-violet-700 border-violet-200",
  ready_made: "bg-teal-100 text-teal-700 border-teal-200",
};
export const MODE_LABELS = { personalized: "Personalized", ready_made: "Ready-made" };

export const shopifyStatusLabel = { draft: "Draft", active: "Active", published: "Live" };

export const SCORE_META = [
  { key: "emotional_pull", label: "Emotional pull", weight: 0.30 },
  { key: "giftability", label: "Giftability", weight: 0.20 },
  { key: "occasion_demand", label: "Occasion demand", weight: 0.20 },
  { key: "competition_opportunity", label: "Low competition", weight: 0.15 },
  { key: "margin_score", label: "Margin potential", weight: 0.10 },
  { key: "seasonality_fit", label: "Seasonality fit", weight: 0.05 },
];

export const KIND_LABELS = {
  idea_generation: "Idea generation",
  package_listing: "Listing packages",
  mockup: "Mockups (image)",
  social: "Social captions",
  order_parse: "Order parsing",
};
